import React from 'react';

const TableHeader = ({ title }: { title: string }): JSX.Element => (
  <div className={'w-6 h-6 transform origin-center -rotate-90'}>
    {title}
  </div>
);

export { TableHeader };
